import React, { useMemo } from 'react'
import styled from 'styled-components'

import { MyTextVertical, TextDataType } from '~/components/ui/MyTextVertical'
import { listFlash_articleGraph_listFlash_edges_node } from '~/graphqls/types'

interface IProps {
  noticeList: listFlash_articleGraph_listFlash_edges_node[]
}

const Wrapper = styled.div`
  position: relative;
  width: 100%;
  margin: 0 auto 40px;
  padding: 0 16px 0 40px;
  border-radius: 32px;
  background: linear-gradient(
    90.24deg,
    rgba(120, 81, 236, 0.88) -1.57%,
    rgba(177, 81, 236, 0.88) 107.51%
  );
  .icon {
    position: absolute;
    left: 16px;
    top: 6px;
    display: block;
    width: 18px;
    height: 18px;
  }
  .list {
    height: 32px;
    overflow: hidden;
    color: #fcfcfd;
    font-weight: 400;
    font-size: 14px;
    &-content {
      width: 100%;
    }
    &-txt {
      width: 100%;
      height: 32px;
      line-height: 32px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
`
export const NoticeSection: React.FC<IProps> = ({ noticeList }) => {
  const noticeInfoList = useMemo((): TextDataType => {
    return !!noticeList.length
      ? noticeList.map(item => {
          return {
            val: item?.post?.title || '',
            link: item?.extra?.jumpLink?.webLink || '',
          }
        })
      : []
  }, [noticeList])

  return (
    <Wrapper>
      <img src="/images/msg/lightBulb.svg" className="icon" alt="" />
      <div className="list">
        <MyTextVertical
          className="list-content"
          contentClassName="list-txt"
          data={noticeInfoList || []}
        ></MyTextVertical>
      </div>
    </Wrapper>
  )
}
